import { gql } from "@apollo/client";

export const FETCH_PLAN_AND_ODOO_INTERNAL_TRANSFER = gql`
  query FETCH_PLAN_AND_ODOO_INTERNAL_TRANSFER($ids: [Int]!, $planId: ID!) {
    odooTransfer(instance: "AB", ids: $ids, useType: "OS_COMPARE")
    productionPlan(id: $planId) {
      id
      finalLines {
        id
        product {
          id
          odooId
          name
          number
          quantityPerCarton
        }
        finalQty
      }
      finalReadyDate
    }
  }
`;

export const FETCH_PLAN_AND_ODOO_SALES_ORDER_DETAIL = gql`
  query FETCH_PLAN_AND_ODOO_SALES_ORDER_DETAIL($ids: [Int]!, $planId: ID!) {
    odooSo(instance: "AB", ids: $ids, useType: "OS_COMPARE")
    productionPlan(id: $planId) {
      id
      odooObject {
        id
        objectId
        objectName
      }
      finalLines {
        id
        product {
          id
          odooId
          name
          number
          quantityPerCarton
        }
        salesPrice
        discountPercentage
        finalQty
      }
      finalReadyDate
    }
  }
`;

export const VALIDATE_PRODUCTION_PLAN = gql`
  query VALIDATE_PRODUCTION_PLAN($planId: ID!) {
    validateProductionPlan(planId: $planId)
  }
`;

export const SYNC_PLAN_TO_ODOO = gql`
  mutation SYNC_PLAN_TO_ODOO(
    $planId: ID!
    $instance: String!
    $orderType: String
  ) {
    syncPlanToOdoo(
      planId: $planId
      instance: $instance
      orderType: $orderType
    ) {
      productionPlan {
        id
      }
    }
  }
`;
